module.exports = __webpack_public_path__ + "img/effect1.add68c60.svg";